(() => {
  if (window.__customBuyNowInstalled) return;
  window.__customBuyNowInstalled = true;

  const ROOT = window.Shopify?.routes?.root || '/';

  function setLoading(button, loading) {
    if (!button) return;

    const text = button.querySelector('.tst-custom-buy-now__text');
    const spinner = button.querySelector('.tst-custom-buy-now__loading');

    button.disabled = loading;

    if (text) {
      text.style.opacity = loading ? '0.65' : '';
    }

    if (spinner) {
      spinner.hidden = !loading;
    }

    button.setAttribute(
      'aria-busy',
      loading ? 'true' : 'false'
    );
  }

  async function addCurrentProduct(form) {
    const formData = new FormData(form);

    // Buy Now goes directly to checkout,
    // so cart drawer sections are not needed.
    formData.delete('sections');
    formData.delete('sections_url');

    const response = await fetch(
      `${ROOT}cart/add.js`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      }
    );

    const data = await response
      .json()
      .catch(() => ({}));

    if (!response.ok) {
      throw new Error(
        data?.description ||
        data?.message ||
        'Could not add product to cart.'
      );
    }

    return data;
  }

  async function waitForFeeSystem() {
    if (
      window.SVCFee &&
      typeof window.SVCFee.syncNow === 'function'
    ) {
      return;
    }

    for (let i = 0; i < 40; i++) {
      await new Promise((resolve) =>
        setTimeout(resolve, 50)
      );

      if (
        window.SVCFee &&
        typeof window.SVCFee.syncNow === 'function'
      ) {
        return;
      }
    }

    throw new Error(
      'SVC Fee system is not available.'
    );
  }

  async function handleBuyNow(button) {
    if (
      !button ||
      button.disabled ||
      button.dataset.processing === 'true'
    ) {
      return;
    }

    const formId =
      button.dataset.productForm;

    const form = document.getElementById(formId);

    if (!form) {
      console.error(
        '[Buy Now] Product form not found:',
        formId
      );

      return;
    }

    button.dataset.processing = 'true';

    setLoading(button, true);

    /*
      Prevent the normal Add to Cart
      background fee sync from running.

      Custom Buy Now will manually wait
      for the fee before checkout.
    */
    window.__svcFeeManualBuyNow = true;

    try {
      /*
        Make sure the SVC fee system is loaded.
      */
      await waitForFeeSystem();

      /*
        1. Add the current selected product.

        FormData keeps:
        - variant ID
        - quantity
        - selling plan
        - line item properties
      */
      await addCurrentProduct(form);

      /*
        2. Wait until the SVC fee
           has actually been added/updated.
      */
      await window.SVCFee.syncNow();

      /*
        3. Go to checkout only after
           the fee is correct.
      */
      window.location.assign(
        `${ROOT}checkout`
      );

    } catch (error) {
      console.error(
        '[Custom Buy Now]',
        error
      );

      window.__svcFeeManualBuyNow = false;

      button.dataset.processing = 'false';

      setLoading(button, false);

      alert(
        error?.message ||
        'Unable to proceed to checkout. Please try again.'
      );
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(
        '[data-custom-buy-now]'
      );

      if (!button) return;

      event.preventDefault();

      handleBuyNow(button);
    }
  );
})();